module.exports = __webpack_public_path__ + "assets/img/sitecheck.44b3618a.svg";